import application from 'application/application';

application.service('downloadService', [
	'API',
	'helper',
	'$http',
	'ngNotify',
	function(API, helper, $http, ngNotify) {
		this.serviceDownload = (params, rota, movement, checkedItems) => {
			$http({
				...helper.http(API.downloads, rota),
				params,
				responseType: 'blob'
			}).then(response => {
				const { data, status } = response;

				if (status > 299)
					return ngNotify.set('Download não concluído.', {
						type: 'error',
						position: 'bottom'
					});

				const regex = /filename=(.*);/;
				const contentDispositionHeader =
					response.headers()['content-disposition'] ||
					`attachment; filename=${Date.now()}.pdf; filename*=UTF-8''${Date.now()}.pdf`;

				const [, filename] = regex.exec(contentDispositionHeader);

				const file = data;

				const isIe = /*@cc_on!@*/ false || !!document.documentMode;

				if (isIe) {
					window.navigator.msSaveOrOpenBlob(file, 'msSaveBlob_testFile.pdf');
					ngNotify.set('Download concluído!', {
						type: 'success',
						position: 'bottom'
					});
				} else {
					const linkEl = document.createElement('a');

					linkEl.href = URL.createObjectURL(file);

					linkEl.download = filename;

					document.body.appendChild(linkEl);

					linkEl.click();

					if (!movement && !!checkedItems)
						checkedItems.forEach(movement => (movement.__checked__ = false));

					ngNotify.set('Download concluído!', {
						type: 'success',
						position: 'bottom'
					});
				}
			});
		};
	}
]);
